import React, { Component } from 'react';
import _ from 'lodash';

import ReactDOM from 'react-dom';

import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";

momentDurationFormatSetup(moment);

import utils from 'Utils/index.js';

import style from './style.scss';

import CallsListItem from '../../calls/CallsListItem/CallsListItem';
import LeadForm from '../LeadForm/LeadForm';
import LeadListItem from '../LeadsListItem/LeadsListItem';

const SAVE_TYPES = {
  CREATE: 1,
  UPDATE: 2
};

export default class LeadsList extends Component{

  constructor(props) {
    super(props);

    this.state = {
      save_type: false,
      save_data: false,
    };

    this.toggleLeadModal = this.toggleLeadModal.bind(this);
    this.saveForm = this.saveForm.bind(this);

  }

  toggleLeadModal(save_type, save_data, client_data) {

    if(save_type) {
      this.setState({
        save_type: save_type,
        save_data,
        client_data,
      });

    } else {

      this.setState({
        save_type: false,
        save_data: false
      });

    }

  }

  saveForm(app_data) {

    if(this.state.save_type) {

      return (
        <LeadForm

          createRemonlineDelivery={this.props.createRemonlineDelivery}

          saveLead={(data) => {

            let mutation;

            switch (this.state.save_type) {

              case SAVE_TYPES.CREATE:

                mutation = this.props.createLead({
                  variables: _.assign({}, data, {
                    client_id: this.state.save_data
                  })
                });

                break;

              case SAVE_TYPES.UPDATE:

                mutation = this.props.updateLead({
                  variables: _.assign({}, data, {
                    id: this.state.save_data.id
                  })
                });

                break;

            }

            return mutation.then(() => {
              this.toggleLeadModal();

              this.props.refetch && this.props.refetch();

            });

          }}

          onClose={() => {

            this.toggleLeadModal();

          }}

          lead={this.state.save_data}

          client={this.state.client_data}

          app_data={app_data}
        />
      );
    }

    return null;


  }

  removeLead(id) {

    const mutation = this.props.removeLead({
      variables: _.assign({}, {
        id: id
      })
    });

    mutation.then(() => {

      this.props.refetch && this.props.refetch();

    });

    return null;


  }


  render() {

    const {leads, app_data, client_id, with_client, client} = this.props;



    return (
      <div className={`container`}>

        {this.saveForm(app_data)}

        <table className="table fixed full_width leads_table">
          <tbody>

          {leads.map((lead) => {

            const client_data = client || lead.client;

            return (
              <LeadListItem
                key={lead.id}
                lead={lead}
                app_data={app_data}
                updateLead={() => {
                  this.toggleLeadModal(SAVE_TYPES.UPDATE, lead, client_data);
                }}

                removeLead={(id) => {

                  if(confirm('Удалить обращение?')) {
                    this.removeLead(id);
                  }
                }}
                with_client={with_client}
              />
            )
          })}

          </tbody>

        </table>

        {/*ADD BUTTON*/}
        {client_id ? <div className="button button_green calls_list_item__add_lead" onClick={() => {

          this.toggleLeadModal(SAVE_TYPES.CREATE, client_id);

        }}>Добавить</div> : null}


      </div>
    );
  }
}

